import { Schema as S } from "effect";
export const Schema = S.String.pipe(S.brand("@open-revenue/schema/SubscriberId"), S.annotations({
    description: "A unique identifier for a subscriber. Usually provided by the subscription provider, like stripe customer_id"
}));
export const Type = Schema.Type;
export const make = (id)=>S.decodeUnknown(Schema)(id);
export const makeUnsafe = (id)=>id;
